/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowRoundTimeBackIcon24Regular = forwardRef('ArrowRoundTimeBackIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M7.956 4.81A8.25 8.25 0 1 1 4.36 15.114a.75.75 0 1 0-1.39.566 9.75 9.75 0 1 0 .779-8.877V3.246a.75.75 0 0 0-1.5 0V9c0 .414.336.75.75.75h5.5a.75.75 0 0 0 0-1.5H4.652a8.25 8.25 0 0 1 3.304-3.44Z" })));
});
